var _effectorFileName = "/builds/gmini/front-common/src/classifier-editor/SelectDependencies/EstimationTree/createTreeModel.ts";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import { combine, createDomain } from 'effector';
import { isNotEmpty } from '@gmini/utils';
import { treeSort } from "../../../helpers";
import * as n from "./../../../Services/EstimationService/Node";
import { getChildren } from "./../../../Services/EstimationService/EstimationService";
var domain = createDomain({
  name: "domain",
  sid: "qd2olz"
});
export var reset = domain.event('reset', {
  name: "reset",
  sid: "c2667j"
}); // Сделать конструктор переиспользуемым другими сервисами

export function createEstimationRepoTreeModel(estimationService, projectUrn$) {
  var repo$ = combine({
    ɔ: [{
      projectUrn: projectUrn$,
      nodes: estimationService.nodes$
    }, function (_ref) {
      var nodes = _ref.nodes,
          projectUrn = _ref.projectUrn;

      if (!projectUrn) {
        return null;
      }

      var key = n.EstimationRepoNode.getKey({
        id: projectUrn
      });
      return n.EstimationRepoNode.getByKey(nodes, key);
    }],
    config: {
      name: "repo$",
      sid: "-gwp89a"
    }
  });
  var root$ = combine({
    ɔ: [{
      nodes: estimationService.nodes$,
      relations: estimationService.relations$,
      repo: repo$
    }, function (_ref2) {
      var nodes = _ref2.nodes,
          relations = _ref2.relations,
          repo = _ref2.repo;
      return repo ? getChildren(nodes, relations, repo) : [];
    }],
    config: {
      name: "root$",
      sid: "-9iyjns"
    }
  });
  var tree$ = combine({
    ɔ: [{
      root: root$,
      nodes: estimationService.nodes$,
      relations: estimationService.relations$
    }, function (_ref3) {
      var root = _ref3.root,
          nodes = _ref3.nodes,
          relations = _ref3.relations;

      function createNode(_ref4) {
        var node = _ref4.node,
            path = _ref4.path;

        var recursive = function recursive(_ref5) {
          var id = _ref5.id,
              type = _ref5.type;
          var node = n.Node.getByRef(nodes, {
            id: id,
            type: type
          });

          if (!node) {
            return null;
          }

          switch (node.type) {
            case 'EstimationRepoFolderNode':
              {
                return {
                  type: node.type,
                  id: node.id,
                  title: node.name,
                  children: getChildren(nodes, relations, node).map(function (node) {
                    return recursive(node);
                  }).filter(isNotEmpty),
                  total: node.total,
                  offset: node.offset
                };
              }

            case 'EstimationNode':
              {
                var _node$estimationPubli;

                var lastPublishedVersion = (_node$estimationPubli = node.estimationPublishedVersions) === null || _node$estimationPubli === void 0 ? void 0 : _node$estimationPubli.reduce(function (acc, item) {
                  if (!acc || acc.classifierVersion < item.classifierVersion) {
                    // eslint-disable-next-line no-param-reassign
                    acc = _objectSpread({}, item);
                  }

                  return acc;
                }, null);
                return {
                  type: node.type,
                  id: id,
                  title: node.name,
                  version: node.version,
                  classifierId: node.classifierId,
                  classifierVersion: (lastPublishedVersion === null || lastPublishedVersion === void 0 ? void 0 : lastPublishedVersion.classifierVersion) || node.classifierVersion,
                  status: !lastPublishedVersion ? 'DRAFT' : 'PUBLISHED',
                  children: [],
                  projectUrn: node.projectUrn
                };
              }

            default:
              return null;
          }
        };

        return recursive(node);
      }

      var tree = root.map(function (node) {
        return createNode({
          node: node,
          path: 1
        });
      }).filter(isNotEmpty);
      return treeSort({
        data: tree,
        itemKey: 'type',
        priorityItemKeyValues: ['EstimationRepoFolderNode']
      });
    }],
    config: {
      name: "tree$",
      sid: "-5j4gsr"
    }
  });
  return tree$;
}